import { Box, Button } from "@material-ui/core";
import { Link } from "react-router-dom";

import { useSummaryStyles } from "./summary.styles";
import { useSelector } from "react-redux";
import { RootState } from "../../../../app/rootReducer";
import { quoteAmountWithOutAddons, quoteImage } from "../../../../app/utils";
import { PriceFormat } from "../../../../components/typography/PriceFormat";

export const SummaryPackage = () => {
  const classes = useSummaryStyles();

  const { quote } = useSelector((state: RootState) => state.quote);

  return (
    <Box className={classes.summaryPackage}>
      <h3 className={classes.summarySectionTitle}>Your packages includes</h3>
      <Box className={classes.summaryPackageProduct}>
        <Box>
          <Box className={classes.summaryPackageProductImage}>
            <img src={quote ? quoteImage(quote) : ""} alt="boiler" width={"100%"} />
          </Box>
        </Box>
        <Box className={classes.summaryPackageProductDetail}>
          <div className={classes.summaryPackageProductName}>{quote?.title || "-"}</div>
          <Box className={classes.summaryPackageProductPrice}>
            <PriceFormat value={quote ? quoteAmountWithOutAddons(quote) : 0} />
            <Button className={classes.summaryPackageProductButton}>
              <Link to={`/quote/${quote?.id}`}>View Details</Link>
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
